import { 
  IEvent,
  EventType,
  createBubbleUpdatedEvent,
  filterEvents,
} from 'js/bubbleCore/events';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { IBouncer } from 'js/bubbleCore/types';
import { Vector2 } from 'js/framework/utils/Vector2';
import { testBubbleRectCollision } from 'js/bubbleCore/handlers/collisions/checkPopOutCollisions';
import {
  getDistance,
  getAngle,
  lengthDirX,
  lengthDirY,
} from 'js/framework/utils/math-utils';

export function resolveBubbleBouncerCollisions(
  board: BubbleGameBoard,
): void {
  filterEvents(board.getEventsQueue(), EventType.BubbleBouncerCollision)
    .forEach((event) => {
      const { bubble, bouncer } = event.data;
      resolveBubbleColliderPosition(bubble, bouncer);
      board.getEventsQueue().push(createBubbleUpdatedEvent(bubble));
    });
};


function resolveBubbleColliderPosition(bubble: Bubble, bouncer: IBouncer): void {
  const pushVel = new Vector2(bubble.velX, bubble.velY).multiply(0.2);
  // const pushVel = new Phaser.Point(bubble.velX, bubble.velY);
  // pushVel.normalize();
  while (testBubbleRectCollision(bubble, bouncer.size)) {
    bubble.hexSpaceX -= pushVel.x;
    bubble.hexSpaceY -= pushVel.y;
  }

  const spd = Math.max(
    0.1, getDistance({x: 0, y: 0}, {x: bubble.velX, y: bubble.velY}) * 0.75
  );

  const colliderCenterX = bouncer.size.x + bouncer.size.width * 0.5;
  const colliderCenterY = bouncer.size.y + bouncer.size.height * 0.5;
  const newAngle = getAngle(
    {x: colliderCenterX, y: colliderCenterY},
    {x: bubble.hexSpaceX, y: bubble.hexSpaceY}
  );

  bubble.velX = lengthDirX(newAngle, spd, true);
  bubble.velY = Math.max(-10, lengthDirY(newAngle, spd, true));
}
